<div *ngIf="osFamily">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>extension</mat-icon>
      {{ osFamily.id ? "OS - " + osFamily.name : "Create new OS" }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ osFamily.id ? "save" : "add" }}</mat-icon>
        {{ osFamily.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="osFamily.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">OS Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()">
            <th>              <micro-valid-label
                for="companyId"
                [model]="osFamily.companyId"
                label="Company"
              ></micro-valid-label></th>
            <td>
              <micro-company-select
                [(companyId)]="osFamily.companyId"
                [required]="true"
              ></micro-company-select>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="code"
                [model]="code"
                label="Code"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #code="ngModel"
                [(ngModel)]="osFamily.code"
                required
                maxlength="32"
                id="code"
                name="code"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="osTypeName"
                [model]="osTypeName"
                label="OS Type"
              ></micro-valid-label>
            </th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbOsType"
                [(id)]="osFamily.osTypeId"
                [defaultOption]="selectedOsType"
                placeholder="OS Type"
                (objectChange)="onOsTypeChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="OS Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="osFamily.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <input
                [(ngModel)]="osFamily.description"
                maxlength="50"
                id="description"
                name="description"
              />
            </td>
          </tr>
          <tr>
            <th [ngClass]="osFamily.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input
                type="checkbox"
                [checked]="osFamily.active === 'Y'"
                (change)="onCheckboxChange($event)"
                id="active"
                name="active"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
